import React from "react";
import MUIDataTable from "mui-datatables";
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment'

// @material-ui/core components
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from 'components/CustomButtons/Button'

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

// import Badge from "components/Badge/Badge.jsx";

import { plugins } from 'helpers';

import { dashboardServices } from 'services';
import { dashboardActions } from "actions/dashboard.actions";


const style = {
    customCardContentClass: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    actionDiv: {
        display: "inline-flex"
    }
};

const pageStyle = { ...style };

const THEME = createMuiTheme({
    ...MTablestyles,
    overrides: {
        ...MTablestyles.overrides,
        MuiTableCell: {
            head: {
                textAlign: "center",
                paddingRight: '24px',
                // "&:nth-child(3)": {
                //     textAlign: "center",
                //     paddingRight: '24px',
                // }
            },
            body: {
                // "&:nth-child(22)": {
                    textAlign: "center",
                    paddingRight: '24px',
                // }
            },
        },
    }
});

class TableDashboardBurnTransactionByCampaign extends React.Component {
    
    componentDidMount(){
        const { dispatch } = this.props;
        dispatch(dashboardActions.getTableBurnTransactionByCampaignDatas());
    }

    getRowData(rowIndex = 0) {
        const { tableDatas } = this.props;
        var data = tableDatas;
        return data[rowIndex];
    }

    render() {
        const { showLoader, burnTransactionByCampaign, visiblePersonalData } = this.props;
       
        let columns = [
            { name: "_id", options: { filter: false, display: "excluded" } },
            { name: "campaignName", label: "Campaign Name"},
            { name: "female", label: "Female"},
            { name: "male", label: "Male"},
            { name: "other", label: "Other"},
        ]

        let options = {
            serverSide: false,
            rowsPerPage: 5,
            selectableRows: "none",
            print: false,
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [5, 10, 20],
            search: false,
            viewColumns: false,
            sort: false,
            paging: false
        };

        return (
            <div id="tableDashboardList">
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={showLoader?0:1}
                        data={ lodash.get(burnTransactionByCampaign,'data') ? lodash.get(burnTransactionByCampaign,'data'):[] }
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { showLoader, burnTransactionByCampaign } = state.dashboard;
    const { visiblePersonalData } = state.authentication;
    return {
        showLoader, burnTransactionByCampaign, visiblePersonalData
    };
}
export default connect(mapStateToProps)(withStyles(pageStyle)(TableDashboardBurnTransactionByCampaign));  